import { render, staticRenderFns } from "./IndexLevel.vue?vue&type=template&id=fe86b01a"
import script from "./IndexLevel.vue?vue&type=script&lang=js"
export * from "./IndexLevel.vue?vue&type=script&lang=js"
import style0 from "./IndexLevel.vue?vue&type=style&index=0&id=fe86b01a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports